import { Platform } from 'react-native';

const PENDING_DASHBOARD_DEEP_LINK_KEY = 'smartsaas_pending_dashboard_deep_link';
const PENDING_DASHBOARD_DEEP_LINK_TTL_MS = 30 * 60 * 1000;

type StoredDeepLink = { path: string; savedAt: number };

function canUseSessionStorage(): boolean {
  return Platform.OS === 'web' && typeof sessionStorage !== 'undefined';
}

/**
 * Web cold loads route every /dashboard/* URL through Loading, and React Navigation then
 * rewrites the address bar to /loading. Remember the requested path so it can be restored
 * after the session check (or after login).
 */
export function stashPendingDashboardDeepLink(path: string): void {
  if (!canUseSessionStorage() || typeof path !== 'string') return;
  const rawPath = path.split('?')[0].replace(/\/+$/, '');
  if (rawPath === '/dashboard' || rawPath === '') return;
  try {
    const payload: StoredDeepLink = { path, savedAt: Date.now() };
    sessionStorage.setItem(PENDING_DASHBOARD_DEEP_LINK_KEY, JSON.stringify(payload));
  } catch {
    /* best-effort */
  }
}

export function consumePendingDashboardDeepLink(): string | null {
  if (!canUseSessionStorage()) return null;
  try {
    const raw = sessionStorage.getItem(PENDING_DASHBOARD_DEEP_LINK_KEY);
    sessionStorage.removeItem(PENDING_DASHBOARD_DEEP_LINK_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredDeepLink;
    if (!parsed?.path || Date.now() - (parsed.savedAt || 0) > PENDING_DASHBOARD_DEEP_LINK_TTL_MS) {
      return null;
    }
    return parsed.path;
  } catch {
    return null;
  }
}

export function clearPendingDashboardDeepLink(): void {
  if (!canUseSessionStorage()) return;
  try {
    sessionStorage.removeItem(PENDING_DASHBOARD_DEEP_LINK_KEY);
  } catch {
    /* best-effort */
  }
}
